var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tags-selector__list"},[_c('p',{staticClass:"tags-selector__list__title"},[_vm._v(_vm._s(_vm.title))]),_vm._l((_vm.filters),function(filter){return _c('tags-selector-item',{key:filter.id,attrs:{"filter":filter,"filter-type":_vm.filterType}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }